import React,{useState,useEffect} from 'react'

import './Navigation.css'



import {top_nav_paths,bottom_nav_paths,hidden_nav_paths,login_nav_paths,alumni_nav_paths} from '../../constants/path.js'

import {Dropdown} from '../../widgets'
import { Link } from 'react-router-dom'
const mobile_logo="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Login-Logout/mobile-logo.webp"
const desktop_logo="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Login-Logout/desktop-logo.webp"
const Navigation = () => {

    const togglemenu=()=>{
        document.querySelector('.offcanvas-collapse').classList.toggle('open')
    }
    const [screen_width,setScreen_width]=useState(window.innerWidth)
    useEffect(()=>{
        const handleResize = () => {
            setScreen_width(window.innerWidth)
          };
          window.addEventListener('resize', handleResize);

          return () => {
            window.removeEventListener('resize', handleResize);
          };
    },[])

  return (
    <div className='navigation'>
        <nav className="navbar navbar-expand-xl navbar-dark" aria-label="Main navigation">
            <div className="container-fluid">
                <a className="navbar-brand" href="/"></a>
                <button className="navbar-toggler border-0" onClick={togglemenu} type="button" id="navbarSideCollapse" data-toggle="collapse" data-target=".navbars" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                
                <div className="navbar-collapse offcanvas-collapse navbars" id="navbarSupportedContent">
                    <div className="container-fluid hi">
                        <ul className="navbar-nav good me-auto mb-2 mb-lg-0">
                            
                            {top_nav_paths.map((item)=><Dropdown func={togglemenu} key={item.id} type={item.type} title={item.title} base={item.basepath} links={item.links}/>)}
                            {(screen_width<1199)&&(hidden_nav_paths.map((item)=><Dropdown func={togglemenu} key={item.id} type={item.type} title={item.title} base={item.basepath} links={item.links}/>))}
                            {login_nav_paths.map((item)=><Dropdown func={togglemenu} key={item.id} type={item.type} title={item.title} base={item.basepath} links={item.links}/>)}
                          {alumni_nav_paths.map((item) => (
  <li className="nav-item" key={item.id}>
    <Link
      to={item.basepath}
      className="nav-link alumni-top-login"
      onClick={togglemenu}
    >
      {item.title}
    </Link>
  </li>
))}
                        </ul>
                    </div>
                </div>
            </div>
        </nav>

        <nav className="navbar sathiyan navbar-expand-lg navbar-dark">
            <div className="container-fluid">
                <a className="navbar-brand" href="/"></a>
                <div className="navbar-collapse offcanvas-collapse navbars" id="navbarsExampleDefault">
                    <div className="container-fluid">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">

                            {bottom_nav_paths.map((item)=><Dropdown key={item.id} type={item.type} title={item.title} base={item.basepath} links={item.links}/>)}

                        </ul>
                    </div>
                </div>
            </div>
        </nav>

        <div className="logo">
            <Link to="/" className="u"><img className='responsive' src={desktop_logo} alt="logo image" /></Link>
            <Link to="/" className="u"><img className='responsive1' src={mobile_logo} alt="logo image" /></Link>
        </div>

    </div>
  )
}

export default Navigation